import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import SplitText from 'gsap/SplitText';

gsap.registerPlugin( ScrollTrigger );

function wrapTextNodes( node ) {
  const walker = document.createTreeWalker( node, NodeFilter.SHOW_TEXT, null, false );
  const textNodes = [];
  
  while ( walker.nextNode() ) {
    const current = walker.currentNode;
    if ( current.textContent.trim().length > 0 ) {
      textNodes.push( current );
    }
  }
  
  textNodes.forEach( textNode => {
    const words = textNode.textContent.split( /(\s+)/ ); // keep spaces
    const fragment = document.createDocumentFragment();
  
    words.forEach( word => {
      if ( /\s+/.test( word ) ) {
        fragment.appendChild( document.createTextNode( word ) );
      } else {
        const span = document.createElement( 'span' );
        span.className = 'fadeWord';
        span.textContent = word;
        fragment.appendChild( span );
      }
    } );
  
    textNode.parentNode.replaceChild( fragment, textNode );
  } );
}

if ( window.innerWidth >= 1200 ) {
  const headingElement = document.querySelector( '.e-stn--text-slide h2' );
  if ( headingElement ) {
    wrapTextNodes( headingElement );
        
    const fadeWords = gsap.utils.toArray( '.fadeWord' );
    gsap.set( fadeWords, { opacity: 0.3, display: 'inline-block'} );
    const section = document.querySelector( '.e-stn--text-slide' );
    const sectionHeight = section.offsetHeight;

    console.clear();

    let split, tl;

    const createSplit = () => {
      split?.revert();
      tl?.revert();
      split = new SplitText( '.e-stn--text-slide h2', {
        type: 'words'
      } );

      tl = gsap
        .timeline( {
          scrollTrigger: {
            trigger: '.e-stn--text-slide',
            start: 'top top',
            end: `+=${sectionHeight}`,
            pin: true,
            pinSpacing: true,
            scrub: 0.75,
            onUpdate: ( trigger ) => {

              if ( trigger.progress > 0.98 ) {
                const textSection = document.querySelector( '.e-stn--text-slide' );
                const sticky = document.querySelector( '.e-div--text-slide-container' );
                sticky.style.height = '100vh';
                textSection.style.position = 'fixed';
                textSection.style.top = '50%';
                textSection.style.transform = 'translateY(-50%)';

              }
            }
          },
        } )
        .to( {}, { duration: 10 } );
      gsap.to( fadeWords, {
        opacity: 1,
        y: 0,
        stagger: 0.05,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: '.e-stn--text-slide',
          start: 'top 60%',
          end: 'bottom top',
          scrub: true
        }
      } );
    };
    createSplit();

    const debouncer = gsap.delayedCall( 0.2, createSplit ).pause();
    window.addEventListener( 'resize', () => {
      debouncer.restart( true );
    } );
  }
}

